import createQueue from 'Helpers/Queue';
import { post } from 'Api';
import store from 'Redux/store';
import { resetUbisoftError, newStateUbisoftError } from 'Redux/ducks/ubisoft-error';


/* eslint-disable arrow-body-style */
export function ubisoftRevealKey(
  orderID,
  bundleID,
  item,
  uplayId,
  uplayTicket,
  ubisoftSkaBundleItem,
  index,
  iid,
) {
  resetUbisoftError();
  const timer = setTimeout(() => {
    newStateUbisoftError({
      status: 40,
      error: 'Ubisoft Redemption Timed Out',
    });
    setTimeout(() => {
      resetUbisoftError();
    }, 5000);
  }, 30000);
  return async (dispatch) => {
    const { response } = await post(dispatch, '/user/orders/ubisoft-redeem', {
      oid: orderID,
      bid: bundleID,
      item,
      pid: item._id,
      uplayId,
      uplayTicket,
      ubisoftSkaBundleItem,
      index,
      iid,
    });

    if (timer) {
      clearTimeout(timer);
    }

    if (response.ok) {
      return window.location.reload(true);
    }

    return newStateUbisoftError({
      status: 10,
      error: 'Ubisoft Redemption Error',
    });
  };
}

const getLocalAtok = () => {
  let localAtok = '';
  let localAtokObject = {};
  const localAtokString = localStorage.getItem('bsatok') || '';
  if (localAtokString && typeof localAtokString === 'string') {
    try {
      localAtokObject = JSON.parse(localAtokString);
    } catch (ex) { return localAtok; }
  }
  if (localAtokObject.value) {
    localAtok = localAtokObject.value;
  }
  return localAtok;
};

export const getAtok = () => {
  const state = store.getState();
  if (state.atok) {
    if (state.atok.value !== '') {
      return state.atok.value;
    }
  }
  return getLocalAtok();
};

async function processRevealKey(orderID, bundleID, item) {
  const { response, data } = await post(store.dispatch, '/user/orders/redeem', {
    oid: orderID,
    bid: bundleID,
    pid: item._id,
    serialId: item.serialId,
    iid: item.iid,
    atok: getAtok(),
  });

  if (response.ok) return data;
  return { key: 'error' };
}

async function processRevealMysteryKey(orderID, bundleID, item) {
  const { response, data } = await post(store.dispatch, '/user/orders/redeem?mysteryNameOnly=1', {
    oid: orderID,
    bid: bundleID,
    pid: item._id,
    serialId: item.serialId,
    iid: item.iid,
  });

  if (response.ok) return data;
  return data;
}


// Don't initiate queue until a user tried to reveal key
let revealQueue;

export async function revealKey(orderID, bundleID, item) {
  if (!revealQueue) {
    revealQueue = createQueue(processRevealKey, 1000);
  }

  return revealQueue(orderID, bundleID, item);
}

let revealMysteryQueue;

export async function revealMysteryKey(orderID, bundleID, item) {
  if (!revealMysteryQueue) {
    revealMysteryQueue = createQueue(processRevealMysteryKey, 1000);
  }

  return revealMysteryQueue(orderID, bundleID, item);
}

export async function mysteryBundleReveal(oid, item) {
  if (item.type !== 'bundle' || !item.bundles || !item.bundles.length) {
    throw new Error('mysteryBundleReveal can only be used with bundles');
  }

  const { iid, _id: pid } = item;

  const { response, data } = await post(store.dispatch, '/user/orders/redeem?mysteryNameOnly=1', { oid, pid, iid });

  if (response.ok) {
    const order = data;

    return order;
  }
  if (!response.ok) return {};

  throw data.message;
}
